import { BaseApiClient } from "./BaseApiClient";
export const TRACKS_ENDPOINTS = {
    ALL: "/Tracks",
};
/**
 * TracksApiClient - client for fetching tracks BFF endpoints
 * @export
 * @class TracksApiClient
 * @extends {BaseApiClient}
 */
export class TracksApiClient extends BaseApiClient {
    /**
     * Fetch all tracks from BFF
     * @throws {RequiredError}
     * @memberof TracksApiClient
     */
    getTracks() {
        let fetchOptions = {
            request: {},
            fetchOptOverride: {
                method: "GET",
                headers: {
                    "Cache-Control": "no-cache"
                }
            }
        };
        return this.executeRequest(TRACKS_ENDPOINTS.ALL, fetchOptions);
    }
}
//# sourceMappingURL=TracksApiClient.js.map